import React, { useState } from "react"

interface DefaultChatProps {
  handleChoice(channel: string): void
}


export const DefaultChat = ({ handleChoice }: DefaultChatProps) => {

  const [start, setStart] = useState(false)

  return (
    <div className="w-full">
      <div className="fixed bottom-0 flex max-h-[86%]  w-full flex-grow flex-col rounded-lg bg-[#EEEAE3] ">
        <div className="flex flex-grow  flex-col  overflow-y-auto overflow-x-hidden p-4 border border-primary h-screen rounded-sm">
          <div></div>
        </div>
        <div className="flex items-center justify-between gap-2 flex-col bg-primary px-2 pb-4 pt-2">
          {
            !start && <button type="button" className="bg-white flex p-4 w-[99%] h-10 justify-center items-center  text-primary font-semibold rounded-md" onClick={() => setStart(true)}>Começar Atendimento</button>
          }

          {
            start && (
              <div className="flex w-full gap-2 items-center justify-between text-primary text-sm ">
                <button type="button" className="bg-white flex p-4 w-[99%] h-8 justify-center items-center   font-semibold rounded-md" onClick={() => handleChoice('WhatsApp')}>WhatsApp</button>
                <button type="button" className="bg-white flex p-4 w-[99%] h-8 justify-center items-center font-semibold rounded-md" onClick={() => handleChoice('Ligação')}>Ligação</button>
              </div>
            )
          }

        </div>
      </div>
    </div >
  )
}